import React from 'react';
import EditModifierState from './editModifierState/EditModifierState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Forms from './components/Forms/Forms';

const EditModifierPage: React.FC = () => {
	return (
		<EditModifierState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditModifierState>
	);
};

export default EditModifierPage;
